<template>
  <v-card id="list">
    <v-container fluid>
      <v-row>
        <v-col cols="2">
          <v-text-field
            v-model="holderName"
            label="請輸入投保人姓名"
          ></v-text-field>
        </v-col>
        <v-col cols="2">
          <salesman-combo v-model="salesman" label="業務員姓名">
          </salesman-combo>
        </v-col>
        <v-col cols="2">
          <v-text-field
            v-model="insurance_number"
            label="請輸入保單號碼"
          ></v-text-field>
        </v-col>
        <v-col cols="2">
          <v-menu
            v-model="renew_date_menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="renewDate"
                label="續期日期"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                clearable
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="renewDate"
              @input="renew_date_menu = false"
              no-title
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-menu
            v-model="insured_dateS_menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="insured_dateS"
                label="投保日期(起)"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                clearable
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="insured_dateS"
              @input="insured_dateS_menu = false"
              no-title
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="2">
          <v-menu
            v-model="insured_dateE_menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="insured_dateE"
                label="投保日期(迄)"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                clearable
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="insured_dateE"
              @input="insured_dateE_menu = false"
              no-title
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn color="primary" class="mr-2" @click="onSearchClick"
            >查詢保單資料</v-btn
          >
          <v-btn
            color="primary"
            class="mr-2"
            @click="onExportClick"
            :disabled="disableExport"
            >列印續期名單</v-btn
          >
          <v-btn color="success" @click="newInsuranceData">新增保單資料</v-btn>
          <p class="mt-3">{{ message }}</p>
        </v-col>
      </v-row>
      <v-row>
        <v-col col="12" sm="12">
          <v-card class="mx-auto" tile>
            <v-card-title
              >保單資料列表
              <v-spacer></v-spacer>
              <v-dialog v-model="dialogShowExcelExportSetting" width="500">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" class="mr-2">
                    匯出Excel
                  </v-btn>
                </template>
                <excel-column-setting
                  @ChangeDialogShowSettingEvent="ChangeDialogExportSetting"
                  :exportLoading="exportLoading"
                ></excel-column-setting>
              </v-dialog>
              <v-dialog v-model="dialogShowSetting" width="500">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on"> 設定列表欄位 </v-btn>
                </template>
                <list-header-setting
                  @ChangeDialogShowSettingEvent="ChangeDialogShowSetting"
                ></list-header-setting>
              </v-dialog>
            </v-card-title>
            <v-data-table
              :headers="getSelectedHeaders"
              :items="insuranceDatas"
              :page.sync="pagination.current"
              :items-per-page="pagination.itemsPerPage"
              disable-pagination
              :hide-default-footer="true"
            >
              <template v-slot:top>
                <v-dialog v-model="dialogDelete" max-width="400px">
                  <v-card max-width="400" color="red lighten-2" dark>
                    <v-card-title class="headline">保單資料刪除</v-card-title>
                    <v-card-subtitle>您確認要刪除此筆資料嗎？</v-card-subtitle>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="white" text outlined @click="closeDelete"
                        >取消</v-btn
                      >
                      <v-btn
                        color="white"
                        light
                        class="error--text"
                        :disabled="deleteLoading"
                        @click="deleteItemConfirm"
                      >
                        <div v-show="!deleteLoading">確定</div>
                        <div v-show="deleteLoading">
                          <v-progress-circular
                            size="25"
                            indeterminate
                          ></v-progress-circular>
                        </div>
                      </v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-icon large class="mr-2" @click="editInsuranceData(item.id)"
                  >mdi-pencil</v-icon
                >
                <v-icon large @click="deleteItem(item)">mdi-delete</v-icon>
              </template>
            </v-data-table>
            <v-pagination
              v-model="pagination.current"
              :length="pagination.total"
              @input="onPageChange"
            ></v-pagination>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import InsuranceDataService from "../../services/InsuranceDataService";
import SalesmanCombo from "../../components/SalesmanCombo";
import ListHeaderSetting from "./ListHeaderSetting";
import ExcelColumnSetting from "./ExcelColumnSetting";
import { mapGetters } from "vuex";

export default {
  name: "insurancedata-list",
  components: {
    SalesmanCombo,
    ListHeaderSetting,
    ExcelColumnSetting,
  },
  data() {
    return {
      dialogDelete: false,
      deleteLoading: false,
      dialogShowSetting: false,
      dialogShowExcelExportSetting: false, //控制顯示「匯出Excel」對話框
      exportLoading: false, //控制顯示「匯出Excel」對話框內的Loading動畫顯示效果
      editedIndex: -1,
      deleteId: -1,
      insuranceDatas: [], //列表資料
      holderName: "", //保單查詢欄位值
      salesman: null,
      insurance_number: "",
      renewDate: "", //
      insured_dateS: "", //
      insured_dateE: "", //
      disableExport: true,
      renew_date_menu: false, //
      insured_dateS_menu: false, //
      insured_dateE_menu: false, //
      message: "",
      pagination: {
        current: 1,
        total: 0,
        itemsPerPage: 20,
      },
    };
  },
  mounted() {
    this.searchInsuranceData();
  },
  setup() {},
  computed: {
    salesmanName() {
      if (this.salesman === null) return "";
      return this.salesman.name;
    },
    ...mapGetters("insurancelist", ["getSelectedHeaders"]),
    ...mapGetters("insuranceexport", ["getSelectColumns"]),
  },
  watch: {
    renewDate: function() {
      this.disableExport = this.renewDate == "" || this.renewDate === null;
    },
  },
  methods: {
    //觸發對話框
    deleteItem(item) {
      this.deleteId = item.id;
      this.dialogDelete = true;
    },
    //對話框內的確認
    deleteItemConfirm() {
      this.deleteLoading = true;
      this.deleteInsuranceData(this.deleteId);
      this.deleteId = -1;
      this.deleteLoading = false;
      this.closeDelete();
    },
    //關閉對話框
    closeDelete() {
      this.dialogDelete = false;
    },
    //關閉顯示欄位對話框
    ChangeDialogShowSetting(value) {
      this.dialogShowSetting = value;
    },
    //關閉Excel匯出對話框
    ChangeDialogExportSetting(value) {
      var exportColumns = this.getSelectColumns;
      InsuranceDataService.exportExcel(
        "excel",
        this.holderName,
        this.salesmanName,
        this.insurance_number,
        this.renewDate,
        this.insured_dateS,
        this.insured_dateE,
        exportColumns
      ).then(
        //完成下載後才關閉對話框
        () => {
          this.dialogShowExcelExportSetting = value;
          this.exportLoading = false;
        }
      );
    },
    searchInsuranceData() {
      InsuranceDataService.findByCondition(
        this.holderName,
        this.salesmanName,
        this.insurance_number,
        this.renewDate,
        this.insured_dateS,
        this.insured_dateE,
        this.pagination.current,
        this.pagination.itemsPerPage
      )
        .then((response) => {
          this.message = response.message;
          this.insuranceDatas = response.list.map(this.getDisplayInsuranceData);
          this.pagination.current = response.current_page;
          this.pagination.total = response.last_page;
          this.pagination.itemsPerPage = parseInt(response.per_page);
        })
        .catch((e) => {
          console.log(e);
        });
    },
    onExportClick() {
      if (this.renewDate == "" || this.renewDate === null) {
        this.message = "請選擇續期日期";
      } else {
        this.message = "下載續期報表";
        InsuranceDataService.exportRenewReport(
          "excel",
          this.holderName,
          this.salesmanName,
          this.renewDate
        );
      }
    },
    onSearchClick() {
      this.pagination.current = 1;
      this.searchInsuranceData();
    },
    onPageChange() {
      this.searchInsuranceData();
    },

    newInsuranceData() {
      let routeData = this.$router.resolve("addinsurancedata");
      window.open(routeData.href, "_blank");
    },

    editInsuranceData(id) {
      let routeData = this.$router.resolve({
        name: "insurancedata-detail",
        params: { id: id },
      });
      window.open(routeData.href, "_inssurancedata-detail-" + id);
    },

    deleteInsuranceData(id) {
      InsuranceDataService.delete(id)
        .then((response) => {
          this.message = response.message;
          this.searchInsuranceData();
        })
        .catch((e) => {
          console.log(e);
        });
    },

    getDisplayInsuranceData(insuranceData) {
      return {
        id: insuranceData.id,
        insurance_number: insuranceData.insurance_number,
        salesman_name: insuranceData.salesman.name,
        insurance_company_name: insuranceData.insurance_company.name,
        holder_name: insuranceData.holder.name,
        insurance_product_name: insuranceData.insurance_product.name,
        period_fee: insuranceData.period_fee,
        insured_date: insuranceData.insured_date,
        contribution_period: insuranceData.contribution_period,
        beneficiary_name: insuranceData.beneficiary_name,
        agency_company_name: insuranceData.agency_company.name,
        currency_type: insuranceData.currency_type,
        insured_name: insuranceData.insured_name,
        second_holder_name: insuranceData.second_holder_name,
        backup_holder_name: insuranceData.backup_holder_name,
        loss_of_mobility: insuranceData.loss_of_mobility,
        effective_date: insuranceData.effective_date,
      };
    },
  },
};
</script>

<style scoped>
.list {
  max-width: 750px;
}
</style>
